import * as $ from "jquery";
import Debouncer from '../../lib/Debouncer';
import './generic-serach';

// add group attributes with JS here if needed
